import React from "react";
import { FormSelectField } from "@components-shared/desktop/inputs";
import { mapLanguagesForFormSelect } from "@utils";
import { LanguageDataType } from "@data-types/membership/registration";

export default function OnboardingNameInput(props: {
	languageData: LanguageDataType[] | null;
	labelClassName?: string;
}) {
	const { languageData, labelClassName } = props;

	return (
		<FormSelectField
			name="cultureInfoName"
			className="form__field u-mar--bottom--reset"
			labelClassName={labelClassName}
			label="registration:CONTACT_LANGUAGE"
			inputClassName="input input--sml input--select"
			dropdownData={mapLanguagesForFormSelect(languageData)}
			required
		/>
	);
}
